/**
 * Clave canónica de un territorio para índices de store.
 * Siempre uppercase. Zona vacía o nula se trata como string vacío.
 * @param {string|null|undefined} zona
 * @param {string|number} numero
 * @returns {string}  Ej: "A1", "12", "BC5"
 */
export function getTerritorioKey(zona, numero) {
  return `${zona || ""}${numero}`.toUpperCase()
}
